export const domains = {
    'stories.digitalhealthatlas.org': 'space/dha',
    'cpims.mosvy.gov.kh': 'space/unicef-cambodia',
    'ndcsforeverychild.unicef.org': 'space/unicef-lacro',
    'ndcsparacadainfancia.unicef.org': 'space/ndc4c-espanol'
}